import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useAudience } from '../contexts/AudienceContext';

const WA = '+918252113477';

const FloatingHelp = ({ onOpenLead }) => {
  const { isSchool } = useAudience();
  const [open, setOpen] = useState(false);

  const waText = isSchool
    ? 'Hi ChooseRightCareer, I want to discuss a school partnership or book a demo.'
    : 'Hi ChooseRightCareer, I want to know more about Career DNA for students.';

  const waHref = `https://wa.me/${WA.replace(/\D/g, '')}?text=${encodeURIComponent(waText)}`;

  return (
    <>
      <div className="fixed bottom-6 right-6 z-[60] flex flex-col items-end gap-3">
        {open && (
          <div className="rounded-2xl bg-white p-4 shadow-2xl border border-gray-100 w-[min(100vw-3rem,280px)]">
            <div className="flex justify-between items-start mb-3">
              <span className="text-sm font-semibold text-gray-900">Need a fast answer?</span>
              <button
                type="button"
                className="p-1 rounded-lg hover:bg-gray-100 text-gray-500"
                onClick={() => setOpen(false)}
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <p className="text-xs text-gray-600 mb-4">
              {isSchool
                ? 'Message us for a focused school demo, or scroll to the partnership form on this page.'
                : 'WhatsApp for a quick question, or open the student form.'}
            </p>
            <div className="flex flex-col gap-2">
              <a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-green-600 to-emerald-600 text-white text-sm font-semibold py-2.5 px-3 hover:opacity-95 transition-opacity"
              >
                <MessageCircle className="h-4 w-4" />
                Chat on WhatsApp
              </a>
              <button
                type="button"
                onClick={() => {
                  setOpen(false);
                  onOpenLead();
                }}
                className="text-sm font-semibold text-blue-700 py-2 hover:underline"
              >
                {isSchool ? 'Go to school form' : 'Go to student form'}
              </button>
            </div>
          </div>
        )}
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-blue-600 to-teal-600 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-blue-300/50"
          aria-expanded={open}
          aria-label="Open help and WhatsApp"
        >
          {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
        </button>
      </div>
    </>
  );
};

export default FloatingHelp;
